import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { lighten, rgba } from 'polished';

const checkedStyles = ({ checked }) => {
  if (checked) {
    return css`
      color: #666;
      background: ${rgba('#000', 0.05)};
      box-shadow: inset 0 1px ${rgba('#000', 0.0275)};
    `;
  }

  return css`
    background: #fff;
    box-shadow: 0 1px ${rgba('#000', 0.0275)};
  `;
};

const Option = styled.label<{ disabled?: boolean; checked: boolean; }>`
  display: flex;
  align-items: center;
  position: relative;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  transition: background 160ms ease;
  border: 1px solid ${lighten(0.76, '#000')};
  cursor: pointer;
  border-radius: 4px;
  
  ${checkedStyles}

  input {
    margin-right: 10px;
  }
`;

export default Option;
